/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Home_CommentInputs */

const en_wc_home_comment = /** @type {(inputs: Wc_Home_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try the editor, follow a tutorial, and decide whether WordCraft fits the way you write.`)
};

/**
* | output |
* | --- |
* | "Try the editor, follow a tutorial, and decide whether WordCraft fits the way you write." |
*
* @param {Wc_Home_CommentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_home_comment = /** @type {((inputs?: Wc_Home_CommentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Home_CommentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_home_comment(inputs)
});
export { wc_home_comment as "wc.home.comment" }